import { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { FaCheck, FaXmark } from 'react-icons/fa6'
import { DateBox } from 'devextreme-react'

const SaveCommercialOfferWithSampleIndexesDataModal = ({ show, onHide }) => {
    const [isExpired, setIsExpired] = useState(false)
    const [expiredDate, setExpiredDate] = useState(null)

    useEffect(() => {
        setExpiredDate(null)
        setIsExpired(false)
    }, [show])

    useEffect(() => {
        if (!isExpired) {
            setExpiredDate(null)
        }
    }, [isExpired])

    const handleDateChanged = (e) => {
        if (e.value) {
            setExpiredDate(e.value)
        }
    }

    return (<Modal size='lg' show={show} onHide={() => onHide(false)} centered>
        <Modal.Header closeButton={true}>
            <Modal.Title>Termin obowiązywania rabatów</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div className='d-flex flex-column'>
                <div className='d-flex'>
                    <span className='me-3'>Termin dla pozycji</span>
                    <div className={`custom-switch ${isExpired ? "active" : ""}`} onClick={() => setIsExpired(!isExpired)}>
                        <div className="custom-switch-circle">
                            {isExpired ? <FaCheck className='primary-accent-color-text' /> : <FaXmark />}
                        </div>
                    </div>
                </div>
                <DateBox
                    adaptivityEnabled={true}
                    value={expiredDate}
                    acceptCustomValue={false}
                    onValueChanged={handleDateChanged}
                    visible={isExpired}
                    className='mt-3'
                    min={new Date()}
                />
            </div>
        </Modal.Body>
        <Modal.Footer>
            <button className='btn-app-primary' onClick={() => onHide({ isAccepted: true, expiredDate })}>Zapisz</button>
            <button className='btn-app-secondary' onClick={() => onHide(false)}>Anuluj</button>
        </Modal.Footer>
    </Modal>)
}

export default SaveCommercialOfferWithSampleIndexesDataModal